import { useEffect, useState, useRef } from 'react';
import { IonModal, IonButton, IonIcon, IonImg, IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSelect, IonSelectOption, IonItem, IonTextarea, useIonToast } from '@ionic/react';
import { close } from 'ionicons/icons';
import { ValidateEmail, ValidateIranMobile, ConvertToEnDigit } from '../../../defines/Functions';
import { Constants } from '../../../defines/Constants';
import { Storage } from '@capacitor/storage';
import MyDatepicker from '../../MyDatepicker';
import axios from 'axios';
import moment from 'jalali-moment';
import Loading from '../../Loading';
import Nationality from './Nationality';
import './ProfileUpdate.css';
import profileUpdate from '../../../assets/images/dashboard-profile-update.svg';

const ProfileUpdate = () => {
    const profileUpdateApi = Constants.api.profileUpdate;
    const profileInfo = Constants.api.profileInfo;
    const [present] = useIonToast();
    const showToast = (options: any) => {
        present({
            buttons: [{ icon: 'close', role: 'cancel' }],
            message: options.message,
            color: options.color,
            duration: 2000
        })
    };
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        showProfileUpdateModal: false,
        token: ''
    });
    const [userData, setUserData] = useState({}) as any;
    const userDataRef = useRef(false);
    const getUserData = async () => {
        if (!userDataRef.current) {
            const { value } = await Storage.get({ key: 'userData' });
            if (value) {
                const objectValue = JSON.parse(value);
                setState(prevState => ({ ...prevState, token: objectValue.token }));
                setUserData(objectValue);
            } else {
                setUserData({});
                return false;
            }
        }
        userDataRef.current = true;
    }
    getUserData();
    const [formData, setFormData] = useState({
        gender: 'm',
        birth_date: '' as any,
        first_name: '',
        last_name: '',
        email: '',
        mobile_no: '',
        city: '',
        postal_code: '',
        nationality: '' as any,
        doc_type: 'm',
        national_code: '',
        passport_code: '',
        passport_exp_date: '' as any,
        address: '',
        sheba: ''
    });
    const [countries, setCountries] = useState({}) as any;
    useEffect(() => {
        const getCountries = async () => {
            const { value } = await Storage.get({ key: 'countries' });
            if (value) {
                const objectValue = JSON.parse(value);
                setCountries(objectValue);
            } else {
                setCountries({});
            }
        }
        getCountries();
    }, []);
    useEffect(() => {
        if (countries.length !== 0) {
            if (Object.keys(userData).length !== 0) {
                let nationalityObj = {} as any;
                Object.values(countries).forEach((c: any) => {
                    if (c.iso === userData.nationality) {
                        nationalityObj = c;
                    }
                })
                setFormData({
                    gender: userData.gender,
                    birth_date: new Date(userData.birth_date),
                    first_name: userData.first_name,
                    last_name: userData.last_name,
                    email: userData.email,
                    mobile_no: userData.mobile_no,
                    city: userData.city,
                    postal_code: userData.postal_code,
                    nationality: nationalityObj,
                    doc_type: userData.doc_type,
                    national_code: userData.national_code,
                    passport_code: userData.passport_code,
                    passport_exp_date: new Date(userData.passport_exp_date),
                    address: userData.address,
                    sheba: userData.sheba
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countries]);
    const [required, setRequired] = useState({
        gender: { value: false, message: '' },
        birth_date: { value: false, message: '' },
        first_name: { value: false, message: '' },
        last_name: { value: false, message: '' },
        email: { value: false, message: '' },
        mobile_no: { value: false, message: '' },
        city: { value: false, message: '' },
        postal_code: { value: false, message: '' },
        nationality: { value: false, message: '' },
        doc_type: { value: false, message: '' },
        national_code: { value: false, message: '' },
        passport_code: { value: false, message: '' },
        passport_exp_date: { value: false, message: '' },
        address: { value: false, message: '' }
    });
    const handleNationalityCalback = (childData: any) => {
        setFormData({ ...formData, nationality: childData });
        setRequired({ ...required, nationality: { value: false, message: '' } });
    }
    const handleBirthDatepickerCallback = (childDataObj: any) => {
        setFormData({ ...formData, birth_date: childDataObj.dates[0] });
        setRequired({ ...required, birth_date: { value: false, message: '' } });
    }
    const handlePassDatepickerCallback = (childDataObj: any) => {
        setFormData({ ...formData, passport_exp_date: childDataObj.dates[0] });
        setRequired({ ...required, passport_exp_date: { value: false, message: '' } });
    }
    const handleChange = (e: any) => {
        const name = e.target.name;
        const value = e.detail.value;
        setFormData(values => ({ ...values, [name]: value }));
    }
    const handleBlur = () => {
        if (formData.gender.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, gender: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, gender: { value: false, message: '' } } });
        }
        if (formData.birth_date.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, birth_date: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, birth_date: { value: false, message: '' } } });
        }
        if (formData.first_name.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, first_name: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, first_name: { value: false, message: '' } } });
        }
        if (formData.last_name.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, last_name: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, last_name: { value: false, message: '' } } });
        }
        if (formData.city.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, city: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, city: { value: false, message: '' } } });
        }
        if (formData.postal_code.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, postal_code: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, postal_code: { value: false, message: '' } } });
        }
        if (formData.nationality.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, nationality: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, nationality: { value: false, message: '' } } });
        }
        if (formData.doc_type.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, doc_type: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, doc_type: { value: false, message: '' } } });
        }
        if (formData.doc_type === 'm') {
            if (formData.national_code.toString().trim().length === 0) {
                setRequired(prevRequired => { return { ...prevRequired, national_code: { value: true, message: 'الزامی' } } });
            } else {
                setRequired(prevRequired => { return { ...prevRequired, national_code: { value: false, message: '' } } });
            }
        }
        if (formData.doc_type === 'p') {
            if (formData.passport_code.toString().trim().length === 0) {
                setRequired(prevRequired => { return { ...prevRequired, passport_code: { value: true, message: 'الزامی' } } });
            } else {
                setRequired(prevRequired => { return { ...prevRequired, passport_code: { value: false, message: '' } } });
            }
            if (formData.passport_exp_date.toString().trim().length === 0) {
                setRequired(prevRequired => { return { ...prevRequired, passport_exp_date: { value: true, message: 'الزامی' } } });
            } else {
                setRequired(prevRequired => { return { ...prevRequired, passport_exp_date: { value: false, message: '' } } });
            }
        }
        if (formData.address.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, address: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, address: { value: false, message: '' } } });
        }
        // ==========================================   MOBILE  ==========================================
        if (formData.mobile_no.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, mobile_no: { value: true, message: 'الزامی' } } });
        } else {
            if (!ValidateIranMobile(formData.mobile_no)) {
                setRequired(prevRequired => { return { ...prevRequired, mobile_no: { value: true, message: 'شماره موبایل معتبر نیست' } } });
            } else {
                setRequired(prevRequired => { return { ...prevRequired, mobile_no: { value: false, message: '' } } });
            }
        }
        // ===========================================   EMAIL  ==========================================
        if (formData.email.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, email: { value: true, message: 'الزامی' } } });
        } else {
            if (!ValidateEmail(formData.email)) {
                setRequired(prevRequired => { return { ...prevRequired, email: { value: true, message: 'آدرس ایمیل معتبر نیست' } } });
            } else {
                setRequired(prevRequired => { return { ...prevRequired, email: { value: false, message: '' } } });
            }
        }
    }
    const handleSubmit = (event: any) => {
        let isRequired = false;
        event.preventDefault();
        if (formData.gender.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, gender: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, gender: { value: false, message: '' } } });
            isRequired = false;
        }
        if (formData.birth_date.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, birth_date: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, birth_date: { value: false, message: '' } } });
            isRequired = false;
        }
        if (formData.first_name.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, first_name: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, first_name: { value: false, message: '' } } });
            isRequired = false;
        }
        if (formData.last_name.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, last_name: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, last_name: { value: false, message: '' } } });
            isRequired = false;
        }
        if (formData.city.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, city: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, city: { value: false, message: '' } } });
            isRequired = false;
        }
        if (formData.postal_code.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, postal_code: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, postal_code: { value: false, message: '' } } });
            isRequired = false;
        }
        if (formData.nationality.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, nationality: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, nationality: { value: false, message: '' } } });
            isRequired = false;
        }
        if (formData.doc_type.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, doc_type: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, doc_type: { value: false, message: '' } } });
            isRequired = false;
        }
        if (formData.doc_type === 'm') {
            if (formData.national_code.toString().trim().length === 0) {
                setRequired(prevRequired => { return { ...prevRequired, national_code: { value: true, message: 'الزامی' } } });
                isRequired = true;
            } else {
                setRequired(prevRequired => { return { ...prevRequired, national_code: { value: false, message: '' } } });
                isRequired = false;
            }
        }
        if (formData.doc_type === 'p') {
            if (formData.passport_code.toString().trim().length === 0) {
                setRequired(prevRequired => { return { ...prevRequired, passport_code: { value: true, message: 'الزامی' } } });
                isRequired = true;
            } else {
                setRequired(prevRequired => { return { ...prevRequired, passport_code: { value: false, message: '' } } });
                isRequired = false;
            }
            if (formData.passport_exp_date.toString().trim().length === 0) {
                setRequired(prevRequired => { return { ...prevRequired, passport_exp_date: { value: true, message: 'الزامی' } } });
                isRequired = true;
            } else {
                setRequired(prevRequired => { return { ...prevRequired, passport_exp_date: { value: false, message: '' } } });
                isRequired = false;
            }
        }
        if (formData.address.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, address: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, address: { value: false, message: '' } } });
            isRequired = false;
        }
        // ==========================================   MOBILE  ==========================================
        if (formData.mobile_no.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, mobile_no: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            if (!ValidateIranMobile(formData.mobile_no)) {
                setRequired(prevRequired => { return { ...prevRequired, mobile_no: { value: true, message: 'شماره موبایل معتبر نیست' } } });
                isRequired = true;
            } else {
                setRequired(prevRequired => { return { ...prevRequired, mobile_no: { value: false, message: '' } } });
                isRequired = false;
            }
        }
        // ===========================================   EMAIL  ==========================================
        if (formData.email.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, email: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            if (!ValidateEmail(formData.email)) {
                setRequired(prevRequired => { return { ...prevRequired, email: { value: true, message: 'آدرس ایمیل معتبر نیست' } } });
                isRequired = true;
            } else {
                setRequired(prevRequired => { return { ...prevRequired, email: { value: false, message: '' } } });
                isRequired = false;
            }
        }
        if (!isRequired) {
            submitForm();
        }
    }
    const submitForm = async () => {
        setLoading(true);
        const submitData = {
            user: [{
                gender: formData.gender,
                first_name: formData.first_name,
                last_name: formData.last_name,
                birth_date: moment(formData.birth_date).format("YYYY-MM-DD"),
                email: formData.email,
                mobile_no: ConvertToEnDigit(formData.mobile_no),
                city: formData.city,
                postal_code: formData.postal_code,
                nationality: formData.nationality.iso,
                doc_type: formData.doc_type,
                national_code: formData.national_code,
                passport_code: formData.passport_code,
                passport_exp_date: moment(formData.passport_exp_date).format("YYYY-MM-DD"),
                address: formData.address,
                sheba: ConvertToEnDigit(formData.sheba)
            }]
        };
        try {
            const formResults = await axios.post(profileUpdateApi, JSON.stringify(submitData), {
                headers: {
                    Authorization: 'Bearer ' + state.token,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            if (formResults.data.result === 'error') {
                showToast({ message: formResults.data.message, color: 'danger' });
                setFormData({
                    gender: 'm',
                    birth_date: '',
                    first_name: '',
                    last_name: '',
                    email: '',
                    mobile_no: '',
                    city: '',
                    postal_code: '',
                    nationality: '',
                    doc_type: 'm',
                    national_code: '',
                    passport_code: '',
                    passport_exp_date: '',
                    address: '',
                    sheba: ''
                });
                setLoading(false);
            } else {
                try {
                    const profileInfoResults = await axios.get(profileInfo, {
                        headers: {
                            Authorization: 'Bearer ' + state.token
                        }
                    });
                    if (profileInfoResults.data.result === 'error') {
                        showToast({ message: profileInfoResults.data.message, color: 'danger' });
                        setLoading(false);
                    } else {
                        await Storage.remove({ key: 'userData' });
                        profileInfoResults.data.token = state.token;
                        await Storage.set({
                            key: 'userData',
                            value: JSON.stringify(profileInfoResults.data),
                        });
                        showToast({ message: formResults.data.message, color: 'success' });
                        setLoading(false);
                        setState({ ...state, showProfileUpdateModal: false });
                        userDataRef.current = false;
                        getUserData();
                    }
                } catch (error: any) {
                    console.log(error);
                    showToast({ message: error.response.data.message, color: 'danger' });
                    setLoading(false);
                }
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }
    return (
        <>
            <IonModal isOpen={state.showProfileUpdateModal} onDidDismiss={() => setState({ ...state, showProfileUpdateModal: false })} mode="ios" cssClass="profile-update-modal">
                <div className="profile-update-modal-content">
                    <h3 className="profile-update-modal-title">
                        ویرایش پروفایل
                        <IonIcon icon={close} onClick={() => setState({ ...state, showProfileUpdateModal: false })} />
                    </h3>
                    <div className="profile-update-modal-input-container">
                        {!loading ?
                            <form onSubmit={handleSubmit}>
                                <IonGrid>
                                    <IonRow>
                                        <IonCol size="6">
                                            <IonLabel>
                                                جنسیت
                                                {required.gender.value ? <span className="required">{required.gender.message}</span> : null}
                                            </IonLabel>
                                            <IonItem lines="none">
                                                <IonLabel>جنسیت</IonLabel>
                                                <IonSelect
                                                    value={formData.gender}
                                                    onIonChange={e => setFormData({ ...formData, gender: e.detail.value })}
                                                    mode="md"
                                                    okText="تایید"
                                                    cancelText="لغو"
                                                >
                                                    <IonSelectOption value="m">مرد</IonSelectOption>
                                                    <IonSelectOption value="f">زن</IonSelectOption>
                                                </IonSelect>
                                            </IonItem>
                                        </IonCol>
                                        <IonCol size="6">
                                            <IonLabel>
                                                تاریخ تولد
                                                {required.birth_date.value ? <span className="required">{required.birth_date.message}</span> : null}
                                            </IonLabel>
                                            <MyDatepicker
                                                value={new Date(formData.birth_date)}
                                                isGregorian={false}
                                                isRange={false}
                                                datepickerParentCallback={handleBirthDatepickerCallback}
                                                maxDate={new Date()}
                                                minDate={moment(new Date()).subtract(200, 'years')}
                                            />
                                        </IonCol>
                                        <IonCol size="6">
                                            <IonLabel>
                                                نام
                                                {required.first_name.value ? <span className="required">{required.first_name.message}</span> : null}
                                            </IonLabel>
                                            <IonInput type="text" name="first_name" value={formData.first_name || ""} onIonChange={handleChange} onIonBlur={handleBlur} />
                                        </IonCol>
                                        <IonCol size="6">
                                            <IonLabel>
                                                نام خانوادگی
                                                {required.last_name.value ? <span className="required">{required.last_name.message}</span> : null}
                                            </IonLabel>
                                            <IonInput type="text" name="last_name" value={formData.last_name || ""} onIonChange={handleChange} onIonBlur={handleBlur} />
                                        </IonCol>
                                        <IonCol size="12">
                                            <IonLabel>
                                                آدرس ایمیل
                                                {required.email.value ? <span className="required">{required.email.message}</span> : null}
                                            </IonLabel>
                                            <IonInput type="email" name="email" value={formData.email || ""} onIonChange={handleChange} onIonBlur={handleBlur} />
                                        </IonCol>
                                        <IonCol size="12">
                                            <IonLabel>
                                                شماره موبایل
                                                {required.mobile_no.value ? <span className="required">{required.mobile_no.message}</span> : null}
                                            </IonLabel>
                                            <IonInput type="tel" name="mobile_no" value={formData.mobile_no || ""} onIonChange={handleChange} onIonBlur={handleBlur} />
                                        </IonCol>
                                        <IonCol size="6">
                                            <IonLabel>
                                                شهر
                                                {required.city.value ? <span className="required">{required.city.message}</span> : null}
                                            </IonLabel>
                                            <IonInput type="text" name="city" value={formData.city || ""} onIonChange={handleChange} onIonBlur={handleBlur} />
                                        </IonCol>
                                        <IonCol size="6">
                                            <IonLabel>
                                                کد پستی
                                                {required.postal_code.value ? <span className="required">{required.postal_code.message}</span> : null}
                                            </IonLabel>
                                            <IonInput type="tel" name="postal_code" value={formData.postal_code || ""} onIonChange={handleChange} onIonBlur={handleBlur} />
                                        </IonCol>
                                        <IonCol size="6">
                                            <IonLabel>
                                                ملیت
                                                {required.nationality.value ? <span className="required">{required.nationality.message}</span> : null}
                                            </IonLabel>
                                            <Nationality nationalityParentCallback={handleNationalityCalback} inputValue={formData.nationality || ''} />
                                        </IonCol>
                                        <IonCol size="6">
                                            <IonLabel>
                                                نوع مدرک
                                                {required.doc_type.value ? <span className="required">{required.doc_type.message}</span> : null}
                                            </IonLabel>
                                            <IonItem lines="none">
                                                <IonLabel>نوع مدرک</IonLabel>
                                                <IonSelect
                                                    value={formData.doc_type}
                                                    onIonChange={e => setFormData({ ...formData, doc_type: e.detail.value })}
                                                    mode="md"
                                                    okText="تایید"
                                                    cancelText="لغو"
                                                >
                                                    <IonSelectOption value="m">کارت ملی</IonSelectOption>
                                                    <IonSelectOption value="p">پاسپورت</IonSelectOption>
                                                </IonSelect>
                                            </IonItem>
                                        </IonCol>
                                        {formData.doc_type === 'm' ?
                                            <IonCol size="12">
                                                <IonLabel>
                                                    کد ملی
                                                    {required.national_code.value ? <span className="required">{required.national_code.message}</span> : null}
                                                </IonLabel>
                                                <IonInput type="tel" name="national_code" value={formData.national_code || ""} onIonChange={handleChange} onIonBlur={handleBlur} />
                                            </IonCol>
                                            :
                                            <>
                                                <IonCol size="6">
                                                    <IonLabel>
                                                        شماره پاسپورت
                                                        {required.passport_code.value ? <span className="required">{required.passport_code.message}</span> : null}
                                                    </IonLabel>
                                                    <IonInput type="tel" name="passport_code" value={formData.passport_code || ""} onIonChange={handleChange} onIonBlur={handleBlur} />
                                                </IonCol>
                                                <IonCol size="6">
                                                    <IonLabel>
                                                        انقضای پاسپورت
                                                        {required.passport_exp_date.value ? <span className="required">{required.passport_exp_date.message}</span> : null}
                                                    </IonLabel>
                                                    <MyDatepicker
                                                        value={new Date(formData.passport_exp_date)}
                                                        isGregorian={false}
                                                        isRange={false}
                                                        datepickerParentCallback={handlePassDatepickerCallback}
                                                    />
                                                </IonCol>
                                            </>
                                        }
                                        <IonCol size="12">
                                            <IonLabel>
                                                آدرس
                                                {required.address.value ? <span className="required">{required.address.message}</span> : null}
                                            </IonLabel>
                                            <IonTextarea rows={7} name="address" value={formData.address || ""} onIonChange={handleChange} onIonBlur={handleBlur}></IonTextarea>
                                        </IonCol>
                                        <IonCol size="12">
                                            <IonLabel>شماره شبا</IonLabel>
                                            <IonInput type="text" name="sheba" value={formData.sheba || ""} onIonChange={handleChange} />
                                        </IonCol>
                                        <IonCol size="12">
                                            <IonButton type="submit" color="warning" expand="block">ویرایش پروفایل</IonButton>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                            </form>
                            :
                            <Loading />
                        }
                    </div>
                </div>
            </IonModal>
            <div className="dashboard-box" onClick={() => setState({ ...state, showProfileUpdateModal: true })}>
                <div>
                    <IonImg src={profileUpdate} />
                </div>
                <div>
                    <b>ویرایش پروفایل</b>
                </div>
            </div>
        </>
    );
};
export default ProfileUpdate;